import React from 'react';

const UpgradeAccount = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17.143 8.51257L18.0532 10.2048L20 10.4383L18.5715 11.7092L18.8572 13.5893L17.143 12.5316L15.4287 13.5893L15.7144 11.7092L14.2859 10.4383L16.2858 10.2048L17.143 8.51257Z'
        fill='black'
      />
      <path
        d='M15.4283 19.7942H14.2854V16.9738C14.2846 16.226 13.9833 15.5092 13.4476 14.9804C12.912 14.4517 12.1858 14.1543 11.4284 14.1534H7.99989C7.24243 14.1543 6.51624 14.4517 5.98063 14.9804C5.44502 15.5092 5.14372 16.226 5.14283 16.9738V19.7942H4V16.9738C4.00124 15.9269 4.42305 14.9233 5.17291 14.1831C5.92277 13.4429 6.93944 13.0265 7.99989 13.0252H11.4284C12.4888 13.0265 13.5055 13.4429 14.2554 14.1831C15.0052 14.9233 15.427 15.9269 15.4283 16.9738V19.7942Z'
        fill='black'
      />
      <path
        d='M9.71376 5.12815C10.2788 5.12815 10.8312 5.29357 11.3011 5.60347C11.7709 5.91338 12.1371 6.35387 12.3534 6.86922C12.5696 7.38458 12.6262 7.95167 12.5159 8.49877C12.4057 9.04587 12.1336 9.54841 11.734 9.94285C11.3344 10.3373 10.8254 10.6059 10.2712 10.7147C9.71693 10.8236 9.14247 10.7677 8.62041 10.5542C8.09835 10.3408 7.65214 9.97927 7.3382 9.51546C7.02426 9.05165 6.8567 8.50636 6.8567 7.94854C6.8567 7.20053 7.15771 6.48315 7.69351 5.95423C8.22932 5.4253 8.95602 5.12815 9.71376 5.12815V5.12815ZM9.71376 4C8.92266 4 8.14932 4.23158 7.49154 4.66545C6.83376 5.09932 6.32109 5.716 6.01834 6.4375C5.7156 7.159 5.63639 7.95292 5.79073 8.71886C5.94506 9.4848 6.32602 10.1884 6.88541 10.7406C7.44481 11.2928 8.15752 11.6689 8.93342 11.8212C9.70933 11.9736 10.5136 11.8954 11.2445 11.5965C11.9753 11.2977 12.6 10.7916 13.0396 10.1422C13.4791 9.49289 13.7137 8.72948 13.7137 7.94854C13.7137 6.90132 13.2922 5.89699 12.5421 5.1565C11.792 4.41601 10.7746 4 9.71376 4V4Z'
        fill='black'
      />
    </svg>
  );
};

export default UpgradeAccount;
